import script from "./ProductPastOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPastOrders.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPastOrders.vue?vue&type=style&index=0&id=12822500&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12822500"]])

export default __exports__